<template>
	<div v-if="embedEnabled">
		<h1>Embedding enabled</h1>
		<div v-if="syncStore.syncing">
			<LoadingSVG />
			<div>{{ syncStore.percentComplete }}%</div>
		</div>
		<div v-else>
			<ButtonSmall
				class="inline"
				@click.prevent="testBeginPresentation()"
			>
				Begin Presentation
			</ButtonSmall>
		</div>
	</div>
	<div v-else>Embedding not enabled.</div>
</template>

<script setup lang="ts">
import Plan from '@/classes/Plan'
import { Session } from '@/classes/Session'
import LoadingSVG from '@/components/common/LoadingSVG.vue'
import ButtonSmall from '@/components/forms/ButtonSmall.vue'
import router from '@/router'
import type { Contact } from '@/services/CloudSync/cloudSyncPlanService'
import { Feature, useFeatureService } from '@/services/featureService'
import { usePlanStore } from '@/stores/plan'
import { useSessionStore } from '@/stores/session'
import { useSyncStore } from '@/stores/sync'
import type { SessionData } from '@/types'

const syncStore = useSyncStore()
const sessionStore = useSessionStore()
const planStore = usePlanStore()
const featureService = useFeatureService()

const embedEnabled = featureService.isEnabled(Feature.FdlEmbed)

const testBeginPresentation = () => {
	// TODO: remove hardcode
	const funeralHomeLocationId = '0015f00001THLmPAAX' // testing w/ O'Connor
	const slideDeckId = '619f579f-26ed-4363-8d26-44286b5eb6c9'

	const testContact: Contact = {
		firstName: 'Bob',
		lastName: 'Testerson',
		middleName: '',
		leadId: null,
		contactId: null,
		opportunityId: null,
		address: '',
		city: '',
		state: 'MN',
		email: '',
		phone: '',
		zip: '',
	}
	beginPresentation([testContact], slideDeckId, funeralHomeLocationId)
}

const beginPresentation = async (
	contacts: Contact[],
	slideDeckId: string,
	funeralHomeLocationId: string
) => {
	const plans = await gatherPlansForEmbed(contacts, funeralHomeLocationId)
	const planIds = plans.map((p) => p.id)
	const session = makeEmbedSession(planIds, slideDeckId, funeralHomeLocationId)

	await sessionStore.startSession(session)
	await router.push({
		name: 'embed-present',
		params: { sessionId: session.id },
	})
}

const makeEmbedSession = (
	planIds: string[],
	slideDeckId: string,
	funeralHomeLocationId: string
): Session => {
	// TODO: validate whether it's a Precoa Funeral Home PSS-2058

	const sessionData: Partial<SessionData> = {
		slideDeckId,
		planIds,
		FuneralHomeLocationId: funeralHomeLocationId,
	}
	return new Session(sessionData)
}
const gatherPlansForEmbed = async (
	contacts: Contact[],
	funeralHomeId: string
): Promise<Plan[]> => {
	const plans: Plan[] = []

	for (const contact of contacts) {
		const plan = new Plan({ ...contact, funeralHomeId })
		await planStore.addPlan(plan)
		plans.push(plan)
	}

	return plans
}
</script>
